document.addEventListener("DOMContentLoaded", function () {
    let quickAddDrawer = document.querySelector(`[data-section-type= 'cart']`)
                                    if (quickAddDrawer) {   
                                        let observer = new MutationObserver(function(mutations) {
                                            mutations.forEach(function(m) {
                                                if (m.addedNodes.length) {
                                                   
                                                    BSS_B2B.observer.cartSubject.listenCartCheckout() 
                                                }
                                            });
                                        });
                                        observer.observe(quickAddDrawer, {childList: true});
                                    }
});